import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import '@polymer/polymer/lib/utils/debounce.js';
/**
 * `model-loader`
 * Pole application view element
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class ModelLoader extends PolymerElement {
  static get is() {
    return 'model-loader';
  }
  static get properties() {
    return {
      items: {
        type: Array
      },
      companyId: {
        type: String
      },
      observers: {
        type: Object,
        value: () => ({})
      }
    };
  }
  static get observers() {
    return ['getData(items, companyId)'];
  }
  async getData(items, companyId) {
    if (items && items.length > 0) {
      for (var property in this.observers) {
        this.observers[property].models.forEach((model) => {
          model.ref.off('value', model.listener);
        });
      }
      this.observers = {};
      if (companyId) {
        items.forEach((item) => {
          let property = this.formatProperty(item);
          if (!this[property]) this._createNotifyingProperty(property);
          this.observers[property] = { initializing: true, models: [] };
          let observer = { ref: FirebaseWorker.ref(`photoheight/company_space/${companyId}/models/${item}`) };
          this.observers[property].models.push(observer);
          observer.listener = observer.ref.on('value', (s) => {
            observer.value = s.val();
            this.computeItem(property);
          });
          this.observers[property].initializing = false;
          this.computeItem(property);
        });
      } else {
        items.forEach((item) => {
          this[this.formatProperty(item)] = null;
        });
      }
    }
  }
  formatProperty(str) {
    if (typeof str !== 'string') {
      return str;
    }
    if (str == 'attributes') return 'otherAttributes';
    str = str.replace(/\//g, '_');
    return str
      .replace(/_(.)/g, function (match, group1) {
        return group1.toUpperCase();
      })
      .trim();
  }
  computeItem(property) {
    if (!this.observers[property].initializing && this.observers[property].models.every((x) => typeof x.value != 'undefined')) {
      let data = {};
      this.observers[property].models.forEach((observer) => {
        this.assignData(data, observer.value, property);
      });
      this[property] = data;
    }
  }
  assignData(target, source, property) {
    for (let key in source) {
      if (property == 'buttonGroups' || property == 'inputModelGroups') {
        target[key] = target[key] || {};
        this.assignData(target[key], source[key]);
      } else {
        if (source[key] == '_remove') {
          delete target[key];
        } else {
          target[key] = source[key];
        }
      }
    }
  }
}
window.customElements.define(ModelLoader.is, ModelLoader);
